export enum UserType {
    SystemAdmin = "SystemAdmin",
    InstitutionAdmin = "InstitutionAdmin",
    InstitutionManager = "InstitutionManager",
    Accountant = "Accountant",
    SaaSOperator = "SaaSOperator",
    User = "User"
}

